// src/components/StreakGrid.tsx
import Loading from '@/components/loading/skeleton';
import { useTradingCampaignDailyStreak } from '../hooks/useTradingCampaigns';
import DayTile from './DayTile';

const StreakGridLoading = () => {
    return (
        <div className="grid grid-cols-4 gap-2">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                <Loading
                    isLoading={true}
                    className="w-[85px] h-[85px]"
                    key={item}
                >
                    <></>
                </Loading>
            ))}
        </div>
    );
};

const StreakGrid = () => {
    // Sử dụng grid-cols-4 để tạo bố cục 4 cột

    const { dataDailyStreak, mutate, isLoading } =
        useTradingCampaignDailyStreak();

    if (isLoading) {
        return <StreakGridLoading />;
    }

    return (
        <div className="grid grid-cols-4 gap-3 mb-8">
            {dataDailyStreak?.map((dayData) => (
                <DayTile key={dayData.id} dayData={dayData} mutate={mutate} />
            ))}
        </div>
    );
};

export default StreakGrid;
